import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { OfferPromotionCarousel } from '../../../components/OfferPromotionCarousel/OfferPromotionCarousel'
import { html } from '../../../utils/htmlParser'
import { StyledHeading } from '../styledHeading'
import { OffersFragment } from '@gql'
import Link from 'next/link'

export type OffersProps = {
  data: OffersFragment[]
  heading?: string | undefined
}

const StyledHomeOfferContainer = styled.div`
  margin-top: 10px;
  ${props => props.theme.breakpoints.up('md')} {
    margin-top: 0;
  }
`
const StyledLink = styled(Link)`
  text-decoration: none;

  ${props => props.theme.breakpoints.down('sm')} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`


export const Offers: React.FC<PropsWithChildren<OffersProps>> = ({ data, heading }) => {
  return (
    <StyledHomeOfferContainer>
      <StyledHeading variant="h5" align="center">
        {heading}
      </StyledHeading>
      <OfferPromotionCarousel>
        {
          data.map((item, index) => (
            item.__typename !== 'offersPromotions_BlockType' ? null :
              <OfferPromotionCarousel flickitySection key={index} variant={ index <= 3 ? 'offer' : 'promotion'}>
                {item?.carouselItemImage?.[0]?.url && (
                  <OfferPromotionCarousel image src={item.carouselItemImage[0].url} alt="" layout="fill" objectFit="cover" objectPosition="center" />
                )}
                <OfferPromotionCarousel contentSection>
                  <StyledLink href={item?.carouselButtonLink?.url || '#'}>
                    <OfferPromotionCarousel title>{item.carouselItemTitle}</OfferPromotionCarousel>
                    {item.carouselItemSubtext && <OfferPromotionCarousel description>{html(item.carouselItemSubtext)}</OfferPromotionCarousel>}
                    {item.carouselButtonText && <OfferPromotionCarousel href={item?.carouselButtonLink?.url || '#'} cta primary buttonColor="black">{item.carouselButtonText}</OfferPromotionCarousel>}
                  </StyledLink>
                </OfferPromotionCarousel>

              </OfferPromotionCarousel>
          ))
        }
      </OfferPromotionCarousel>
    </StyledHomeOfferContainer>
  )
}